// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"c9488155","108":"bce76e66","183":"f198da4f","229":"a6cdf37a","504":"a8129c01"}[chunkId] + ".chunk.css";
};